const setUserId = (state, id) => {
  state.userId = id;
};

const setUserName = (state, name) => {
  state.userName = name;
};

const setToken = (state, jwt) => {
  state.token = jwt;
};

const setNumbers = (state, numbers) => {
  state.numbers = Array.from(numbers);
};

const setActiveNumber = (state, number) => {
  state.activeNumber = number;
};

const setId = (state, id) => {
  state.id = id;
};

const setContacts = (state, contacts) => {
  state.contacts = contacts;
};

const setAccountId = (state, accountId) => {
  state.accountId = accountId;
};

const setFirstName = (state, firstName) => {
  state.firstName = firstName;
};

const setLastName = (state, lastName) => {
  state.lastName = lastName;
};

const setEmail = (state, email) => {
  state.email = email;
};

const setEnterpriseId = (state, enterpriseId) => {
  state.enterpriseId = enterpriseId;
};

const setGroups = (state, groups) => {
  state.groups = groups;
};

const unregisterUser = state => {
  state.userId = '';
  state.userName = '';
  state.firstName = '';
  state.lastName = '';
  state.email = '';
  state.accountId = '';
  state.enterpriseId = '';
  state.id = '';
  state.group = '';
  state.contacts = [];
  state.activeNumber = null;
  state.numbers = [];
};

export default {
  setUserId,
  setUserName,
  setToken,
  setNumbers,
  setActiveNumber,
  setId,
  setContacts,
  setAccountId,
  setFirstName,
  setLastName,
  setEmail,
  setEnterpriseId,
  setGroups,
  unregisterUser
};
